export enum EBrandIconIconPathShared {
  Search = '/images/big-icons/search.png',
  Mail = '/images/big-icons/mail.png',
  Bonus = '/images/big-icons/bonus.png',
  Cashback = '/images/big-icons/cashback.png',
  Calendar = '/images/big-icons/calendar.png',
  Account = '/images/big-icons/account.png',
  AccountSad = '/images/big-icons/account.png',
  Sof = '/images/big-icons/sof.png',
  Password = '/images/big-icons/password.png',
  ResponsibleGaming = '/images/big-icons/responsible-gaming.png',
  Deposit = '/images/big-icons/deposit.png',
  Withdraw = '/images/big-icons/withdraw.png',
  BonusExpired = '/images/big-icons/bonus-expired.png',
  Pause = '/images/big-icons/pause.png',
  Stop = '/images/big-icons/stop.png',
  Break = '/images/big-icons/break.png',
  Manager = '/images/big-icons/manager.png',
  LoyaltyVip = '/images/big-icons/loyalty-vip.png',
  BonusVip = '/images/big-icons/bonus-vip.png',
  BonusPackWelcome = '/images/big-icons/bonus-pack-welcome.png',
  NewGame = '/images/big-icons/new-game.png',
  BonusBirthday = '/images/big-icons/bonus-birthday.png',
  Sfs = '/images/big-icons/sfs.png',
  Fs = '/images/big-icons/fs.png',
  Recharge = '/images/big-icons/recharge.png',
  DepositOne = '/images/big-icons/deposit-1.png',
  Mystery = '/images/big-icons/mystery.png',
  BonusSfs = '/images/big-icons/bonus-sfs.png',
  BonusFs = '/images/big-icons/bonus-fs.png',
  BonusRecharge = '/images/big-icons/bonus-recharge.png',
  BonusDeposit = '/images/big-icons/bonus-deposit.png',
  BonusMystery = '/images/big-icons/bonus-mystery.png',
  NoBonus = '/images/big-icons/bonus-no.png',
  Gift = '/images/big-icons/gift.png',
  Support = '/images/big-icons/support.png',
  RegisterMarkLight = '/images/big-icons/mark-light.png',
  AgeRestrict = '/images/big-icons/age-restriction.png',
  AgeRestrictSad = '/images/big-icons/age-restriction-sad.png',
  RegisterMark = '/images/big-icons/mark.svg',
  Age18 = '/images/big-icons/age-18.svg',
  Age21 = '/images/big-icons/age-21.svg',
  Age21Light = '/images/big-icons/age21-light.png',
  Coins = '/images/big-icons/loss-limit.png',
  BestGame = '/images/big-icons/best-game.png',
  VipYellow = '/images/big-icons/vip-yellow.svg',
  BonusFreespinsDisabled = '/images/big-icons/bonus-freespins-disabled.png',
  BonusMysteryDisabled = '/images/big-icons/bonus-mystery-disabled.png',
  BonusDepositDisabled = '/images/big-icons/bonus-deposit-disabled.png',
  BonusRechargeDisabled = '/images/big-icons/bonus-recharge-disabled.png',
  DepositDisabled = '/images/big-icons/deposit-disabled.png',
  WithdrawDisabled = '/images/big-icons/withdraw-disabled.png',
  Limits = '/images/big-icons/limits.png',
  Identity = '/images/big-icons/confirm-identity.png',
  Notification = '/images/big-icons/notification.png',
  Location = '/images/big-icons/location.png',

  // random wheel
  BonusWheelWheel = '/images/wheel-bonus/bonus-wheel.png',
  // wheel images
  WheelGame = '/images/big-icons/bonus-game.webp',
  WheelJackpot = '/images/big-icons/bonus-jackpot-flat.webp',
  WheelCashback = '/images/big-icons/bonus-money-flat.webp',
  WheelMspins = '/images/big-icons/bonus-mspins.webp',
  WheelSfs = '/images/big-icons/bonus-sfs.webp',
  WheelRmoney = '/images/big-icons/bonus-rmoney.webp',
  WheelFspins = '/images/big-icons/bonus-fspins.webp',
  WheelSecondaryGame = '/images/big-icons/wheel/bonus-game-secondary.webp',
  WheelSecondaryJackpot = '/images/big-icons/wheel/bonus-jackpot-secondary.webp',
  WheelSecondaryCashback = '/images/big-icons/wheel/bonus-money-secondary.webp',
  WheelSecondaryMspins = '/images/big-icons/wheel/bonus-ms-secondary.webp',
  WheelSecondarySfs = '/images/big-icons/wheel/bonus-sfs-secondary.webp',
  WheelSecondaryRmoney = '/images/big-icons/wheel/bonus-rmoney-secondary.webp',
  WheelSecondaryFspins = '/images/big-icons/wheel/bonus-fspins-secondary.webp',
}

export enum EBrandIconStatusPathShared {
  NONE = '',
  ATTENTION = '/images/notifications/status/attention.png',
  FAILED = '/images/notifications/status/failed.png',
  PAUSE = '/images/notifications/status/pause.png',
  PENDING = '/images/notifications/status/pending.png',
  PLAY = '/images/notifications/status/play.png',
  PLUS = '/images/notifications/status/plus.png',
  STOP = '/images/notifications/status/stop.png',
  SUCCESS = '/images/notifications/status/success.png',
  UPDATE = '/images/notifications/status/update.png',
  VERIFY = '/images/notifications/status/verify.png',
  WARNING = '/images/notifications/status/warning.png',
}

export enum EBrandIconStatusStrokeShared {
  NONE = '',
  STROKE = '', //add when icons available
  STROKE_VERIFY = '', //add when icons available
}

/**example of overriding*/
// icons[6] = (
//   <>
//     <g>
//       <mask fill="currentColor" x="0" y="0" width="24" height="24">
//         <rect width="24" height="24" fill="currentColor" />
//       </mask>
//       <g>
//         <path
//           d="M3 18.5V16.5H5V18.5H3ZM3 15V13H5V15H3ZM3 11.5V9.5H5V11.5H3ZM6.5 22V20H8.5V22H6.5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16ZM10 22V20H12V22H10ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20H5V22ZM13.5 22V20H15.5C15.5 20.55 15.3042 21.0208 14.9125 21.4125C14.5208 21.8042 14.05 22 13.5 22ZM3 8C3 7.45 3.19583 6.97917 3.5875 6.5875C3.97917 6.19583 4.45 6 5 6V8H3Z"
//           fill="currentColor"
//         />
//       </g>
//     </g>
//   </>
// )
